
import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface FlaggedActivityData {
  id: string;
  createdAt: string;
  affiliateName: string;
  type: string;
  reason: string;
  status: string;
}

interface MobileFlaggedActivityCardProps {
  activity: FlaggedActivityData;
  onInvestigate: (id: string) => void;
  onDismiss: (id: string) => void;
}

export const MobileFlaggedActivityCard = ({ 
  activity, 
  onInvestigate, 
  onDismiss 
}: MobileFlaggedActivityCardProps) => {
  return (
    <Card className="w-full">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-base truncate">{activity.affiliateName}</h3>
            <div className="flex items-center gap-2 mt-1">
              <Badge className={
                activity.status === 'new' 
                  ? 'bg-botscheme-ruby-red/20 text-botscheme-ruby-red' 
                  : activity.status === 'investigating'
                  ? 'bg-botscheme-amber-gold/20 text-botscheme-amber-gold'
                  : 'bg-botscheme-emerald-green/20 text-botscheme-emerald-green'
              }>
                {activity.status}
              </Badge>
              <span className="text-sm text-muted-foreground">
                {new Date(activity.createdAt).toLocaleDateString()}
              </span>
            </div>
          </div>
        </div>
      </CardHeader>
      
      <CardContent className="pt-0 space-y-3">
        <div className="text-sm">
          <span className="text-muted-foreground">Type:</span>
          <p className="font-medium">{activity.type}</p>
        </div>
        
        <div className="text-sm">
          <span className="text-muted-foreground">Reason:</span>
          <p className="text-sm leading-relaxed mt-1">{activity.reason}</p>
        </div>
        
        {activity.status !== 'resolved' && (
          <div className="flex gap-2 pt-2">
            {activity.status !== 'investigating' && (
              <Button 
                variant="outline" 
                size="sm"
                className="flex-1"
                onClick={() => onInvestigate(activity.id)}
              >
                Investigate
              </Button>
            )}
            <Button 
              variant="ghost" 
              size="sm" 
              className="flex-1"
              onClick={() => onDismiss(activity.id)}
            >
              Dismiss
            </Button>
          </div>
        )}
        
        {activity.status === 'resolved' && (
          <div className="pt-2">
            <span className="text-sm text-muted-foreground">Resolved</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
